import { render, staticRenderFns } from "./MonthlyConsumption.vue?vue&type=template&id=bcc2b9a8&"
import script from "./MonthlyConsumption.vue?vue&type=script&lang=js&"
export * from "./MonthlyConsumption.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyConsumption.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports